import jwtDecode from "jwt-decode";

export class JwtUtil {
    public static decode(token: string) {
        return jwtDecode(token);
    }
}